import React from "react";

const countryOptions = {
  AU: ["Australia", "Australian"],
  CA: ["Canadá", "Canadian"],
  IE: ["Irlanda", "Dublin Irish"],
  UK: ["Reino Unido", "British RP"],
  US: ["Estados Unidos", "General American"],
};

export const AdminTutorForm = ({
  errors,
  form,
  onCancel,
  onChange,
  onSubmit,
  submitting,
}) => (
  <div className="mt-10 wk-card p-8">
    <div className="wk-eyebrow mb-4">Nuevo tutor</div>
    <div className="grid md:grid-cols-2 gap-5">
      <div>
        <label className="block text-[13px] font-medium mb-1.5" style={{ color: "#1E1924" }}>
          Nombre y inicial
        </label>
        <input
          className="wk-input"
          placeholder="Sarah M."
          value={form.display_name}
          onChange={(event) => onChange({ display_name: event.target.value })}
          data-testid="admin-form-name"
        />
        {errors.display_name ? <div className="mt-1 text-[12px]" style={{ color: "#7228C8" }}>{errors.display_name}</div> : null}
      </div>
      <div>
        <label className="block text-[13px] font-medium mb-1.5" style={{ color: "#1E1924" }}>
          Iniciales (2 letras)
        </label>
        <input
          className="wk-input"
          placeholder="SM"
          value={form.initials}
          maxLength={2}
          onChange={(event) => onChange({ initials: event.target.value.toUpperCase() })}
          data-testid="admin-form-initials"
        />
        {errors.initials ? <div className="mt-1 text-[12px]" style={{ color: "#7228C8" }}>{errors.initials}</div> : null}
      </div>
      <div>
        <label className="block text-[13px] font-medium mb-1.5" style={{ color: "#1E1924" }}>País</label>
        <select
          className="wk-input"
          value={form.country_code}
          onChange={(event) => {
            const [country, accent] = countryOptions[event.target.value];
            onChange({ country, country_code: event.target.value, accent });
          }}
          data-testid="admin-form-country"
        >
          {Object.keys(countryOptions).map((code) => <option key={code} value={code}>{countryOptions[code][0]}</option>)}
        </select>
      </div>
      <div>
        <label className="block text-[13px] font-medium mb-1.5" style={{ color: "#1E1924" }}>Especialidad</label>
        <input className="wk-input" value={form.specialty} onChange={(event) => onChange({ specialty: event.target.value })} data-testid="admin-form-specialty" />
      </div>
      <div>
        <label className="block text-[13px] font-medium mb-1.5" style={{ color: "#1E1924" }}>Referencia interna</label>
        <input type="number" min={1} max={20} className="wk-input" value={form.price_per_second_cents} onChange={(event) => onChange({ price_per_second_cents: parseInt(event.target.value || 0, 10) })} data-testid="admin-form-price" />
        {errors.price_per_second_cents ? <div className="mt-1 text-[12px]" style={{ color: "#7228C8" }}>{errors.price_per_second_cents}</div> : null}
        <div className="text-[12px] mt-1" style={{ color: "#70667A" }}>El pack público se muestra como $22.</div>
      </div>
      <div>
        <label className="block text-[13px] font-medium mb-1.5" style={{ color: "#1E1924" }}>Color de avatar</label>
        <div className="flex gap-2">
          {["#7228C8", "#1E1924", "#70667A"].map((color) => (
            <button key={color} type="button" onClick={() => onChange({ avatar_color: color })} className="w-10 h-10 rounded-full" style={{ background: color, border: form.avatar_color === color ? "3px solid #1E1924" : "1px solid #DEDAE2" }} data-testid={`admin-avatar-color-${color.slice(1)}`} />
          ))}
        </div>
      </div>
      <div className="md:col-span-2">
        <label className="block text-[13px] font-medium mb-1.5" style={{ color: "#1E1924" }}>Bio (con carácter)</label>
        <textarea className="wk-input" rows={3} value={form.bio} onChange={(event) => onChange({ bio: event.target.value })} data-testid="admin-form-bio" />
        {errors.bio ? <div className="mt-1 text-[12px]" style={{ color: "#7228C8" }}>{errors.bio}</div> : null}
      </div>
    </div>
    <div className="flex gap-3 mt-6">
      <button type="button" onClick={onSubmit} disabled={submitting} className="wk-btn wk-btn-primary" data-testid="admin-form-submit">
        {submitting ? "Guardando…" : "Guardar como pendiente"}
      </button>
      <button type="button" onClick={onCancel} className="wk-btn wk-btn-ghost">Cancelar</button>
    </div>
  </div>
);